import Vue from 'vue'
import Router from 'vue-router'

// 圈子
const home = ()=>import('@/components/home')
// 消息，获赞
const msg = ()=>import('@/components/msg')
// 我的
const my = ()=>import('@/components/my')
// 我的帖子
const my_posts = ()=>import('@/components/my_posts')
// 我的收藏
const my_collection = ()=>import('@/components/my_collection')
// 我的编辑资料
const edit_info = ()=>import('@/components/edit_info')
// 我的编辑图片
const edit_info_img = ()=>import('@/components/edit_info_img')
// 我的编辑昵称
const edit_info_nickname = ()=>import('@/components/edit_info_nickname')
// 我的获赞
const my_zan = ()=>import('@/components/my_zan')
// 帖子首页
const game = ()=>import('@/components/game')
// 帖子详情
const post_details = ()=>import('@/components/post_details')
// 发帖子
const post_send = ()=>import('@/components/post_send')
// 搜索
const search = ()=>import('@/components/search')
// 我的评论
const my_comment = ()=>import('@/components/my_comment')
// 登录
const login = ()=>import('@/components/login')

Vue.use(Router)

export default new Router({
  routes: [
      //地址为空时跳转home页面
      {
          path: '',
          redirect: '/home'
      },
      {
          name:'home',
          path: '/home',
          component: home
      },
      {
          name:'msg',
          path: '/msg',
          component: msg
      },
      {
          name:'my',
          path: '/my',
          component: my
      },
      {
          name:'my_collection',
          path: '/my_collection',
          component: my_collection
      },
      {
          name:'my_posts',
          path: '/my_posts',
          component: my_posts
      },
      {
          name:'edit_info',
          path: '/edit_info',
          component: edit_info
      },
      {
          name:'my_zan',
          path: '/my_zan',
          component: my_zan
      },
      {
          name:'game',
          path: '/game',
          component: game,
          // meta: {
          //     keepAlive:true ,// 该路由会被缓存
          // }
      },
      {
          name:'post_details',
          path: '/post_details',
          component: post_details
      },
      {
          name:'post_send',
          path: '/post_send',
          component: post_send
      }
      ,
      {
          name:'search',
          path: '/search',
          component: search
      }
      ,
      {
          name:'my_comment',
          path: '/my_comment',
          component: my_comment
      }
      ,
      {
          name:'edit_info_img',
          path: '/edit_info_img',
          component: edit_info_img
      },
      {
          name:'edit_info_nickname',
          path: '/edit_info_nickname',
          component: edit_info_nickname
      },
      {
          name:'login',
          path: '/login',
          component: login
      }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js